import React from "react";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import PropTypes from "prop-types";
import { formatDate } from "../utils/functions";
import PrimaryNormal from "../buttons/PrimaryNormal";

const ExportExcel = ({ arrayData }) => {
  const status = (value) => {
    if (value === "AFFILIATE") {
      return "Afiliado(a)";
    } else if (value === "PENDING_REQUEST") {
      return "Pendiente";
    } else {
      return "No afiliado(a)";
    }
  };

  // console.log(arrayData);

  const ArrNewData = arrayData?.map((item) => {
    return {
      ESTADO: status(item.isAffiliated),
      NOMBRE: item.firstName,
      APELLIDO: item.lastName,
      "CORREO ELECTRÓNICO": item.email,
      "FECHA DE NACIMIENTO": formatDate(item.birthDate),
      SEXO: item.gender === "MALE" ? "MASCULINO" : "FEMENINO",
      "TIPO DE DOCUMENTO": item.documentType.name,
      "NUMERO DE DOCUMENTO": item.documentNumber,
      "FECHA DE EXPEDICIÓN": formatDate(item.documentExpirationDate),
      DEPARTAMENTO: item.state.name,
      MUNICIPIO: item.city.name,
      "BARRIO/DIRECCIÓN": item.neighborhood,
      EPS: item.ePS.name,
      "NÚMERO 1": item.phoneNumber,
      "NÚMERO 2": item.secondaryPhoneNumber,
      WHATSAPP: item.optionalPhoneNumber,
      "FECHA DE SOLICITUD": formatDate(item.created),
      "CABEZA DE FAMILIA": item.dependentChildren ? "Si" : "No",
      "REPRESENTANTE DE MENOR": item.isAdultSupervision ? "Si" : "No",
      "NO CAPACIDAD DE PAGO": "Aceptado",
    };
  });

  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(ArrNewData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, `Historial integración migrante ${new Date().toDateString()}${fileExtension}`);
  };

  return (
    <PrimaryNormal title="Exportar" onClick={() => exportToExcel()} style={{ width: 150, height: 30, margin: 0 }} />
  );
};

ExportExcel.propTypes = {
  arrayData: PropTypes.array,
};

export default ExportExcel;
